import React from 'react';
import ErrorInfo from '../errorInfo/errorInfo';
interface Props {
  children?: any
}
interface State {
  hasError?: any;
  error?: Error;
  errorMsg?: any;
}
class ErrorBoundary extends React.Component<Props, State>{
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error: any) {
    let errorMsg = JSON.stringify(error.stack)
    this.setState({ errorMsg })
  }
  render() {
    if (this.state.hasError) {
      return (
        <ErrorInfo
          errorUpdate={this.state.errorMsg}
        />
      )
    }
    return this.props.children;
  }
}
export default ErrorBoundary;

